import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";
import { requestPayout } from "../../pages/Balances/settlementsAPI";
import { invalidateNotificationsQueries } from "./notifications";

const FETCH_SETTLEMENTS_PAYIN_DETAILS = async (data) => {
  const response = await api.post(
    API_ROUTES.GET_SETTLEMENTS_PAYIN_DETAILS,
    data,
  );
  return response.data;
};

export const getSettlementsPayInDetails = (data) => {
  return useQuery({
    queryKey: ["settlementsPayInDetails", data.data],
    queryFn: () => FETCH_SETTLEMENTS_PAYIN_DETAILS(data.data),
    enabled: !!data.data.businessId && data.activeToggle === "Settlements",
  });
};

const FETCH_SETTLEMENTS_PAYOUT_DETAILS = async (data) => {
  const response = await api.post(
    API_ROUTES.GET_SETTLEMENTS_PAYOUT_DETAILS,
    data,
  );
  return response.data;
};

export const getSettelementsPayOutDetails = (data) => {
  return useQuery({
    queryKey: ["settlementsPayOutDetails", data.data],
    queryFn: () => FETCH_SETTLEMENTS_PAYOUT_DETAILS(data.data),
    enabled: !!data.businessId && data.activeToggle === "Payouts",
  });
};

type RequestPayoutArgs = {
  payload: { message: string };
  token?: string | null;
};

export const useRequestPayout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ payload, token = null }: RequestPayoutArgs) =>
      requestPayout(payload, token),
    onSuccess: () => {
      invalidateNotificationsQueries(queryClient);
    },
  });
};
